document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll(
    '.maxtemp-nutrition_floating_image, .maxtemp-scoop-intro-floatingimage, .maxtemp-build-meal__floating img,.maxtemp-cn__deco-img,.maxtemp-ss__deco-br img'
  );

  if (!images.length) return;

  window.addEventListener('scroll', function () {
    const scrollY = window.scrollY;
    const rotation = scrollY * 0.2;

    images.forEach(img => {
      img.style.transform = `rotate(${rotation}deg)`;
    });
  });
});

function getQuickBuyModalFromEventTarget(target) {
  if (!target) return null;
  if (target.matches && target.matches('quick-buy-modal')) return target;
  return target.closest ? target.closest('quick-buy-modal') : null;
}

function initMaxtempQuickBuySwiper(modal) {
  if (typeof Swiper === 'undefined') return;
  // Do not depend on gallery wrapper class names (custom HTML may differ)
  var el = modal.querySelector('.maxtemp-swiper');
  if (!el) return;

  if (el.swiper) {
    el.swiper.destroy(true, true);
  }

  var totalEl =
    el.querySelector('.maxtemp-count .total') || modal.querySelector('.maxtemp-count .total');
  var currentEl =
    el.querySelector('.maxtemp-count .current') || modal.querySelector('.maxtemp-count .current');
  var nextBtn = el.querySelector('.maxtemp-next') || modal.querySelector('.maxtemp-next');
  var prevBtn = el.querySelector('.maxtemp-prev') || modal.querySelector('.maxtemp-prev');

  var instance = new Swiper(el, {
    loop: false,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    watchOverflow: true,
    navigation:
      nextBtn && prevBtn
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
          }
        : undefined,
    on: {
      init: function (swiper) {
        if (totalEl) totalEl.textContent = swiper.slides.length;
        if (currentEl) currentEl.textContent = swiper.realIndex + 1;
        // Modal was display:none; dimensions are often wrong until after paint
        requestAnimationFrame(function () {
          swiper.update();
          if (swiper.navigation && swiper.navigation.update) {
            swiper.navigation.update();
          }
        });
      },
      slideChange: function (swiper) {
        if (currentEl) currentEl.textContent = swiper.realIndex + 1;
      },
    },
  });

  // Second pass: layout inside dialog can settle one frame late (grid / fonts / CSS)
  setTimeout(function () {
    if (!instance || !instance.el) return;
    instance.update();
    if (instance.navigation && instance.navigation.update) {
      instance.navigation.update();
    }
  }, 0);
  setTimeout(function () {
    if (!instance || !instance.el) return;
    instance.update();
  }, 100);
}

function scheduleMaxtempQuickBuySwiperInit(modal) {
  // Wait until the dialog is visible and layout has run (avoids 0-width Swiper)
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      initMaxtempQuickBuySwiper(modal);
    });
  });
}

// Theme dispatches `dialog:after-show` with default CustomEvent (bubbles: false), so it never
// reaches document in the bubble phase — must use capture to hear it on document.
document.addEventListener(
  'dialog:after-show',
  function (e) {
    var modal = getQuickBuyModalFromEventTarget(e.target);
    if (!modal) return;
    if (!modal.querySelector('.maxtemp-swiper')) return;
    scheduleMaxtempQuickBuySwiperInit(modal);
  },
  true
);
/* ──────────────────────────────────────────────────────────────────────────
   Quick View — in-modal flavour / format switching.
   When a flavour swatch (.mm-siblings__link) or the Pouch/Sachet toggle
   (a.mm-format__btn) is clicked INSIDE the quick-buy modal, load that product's
   quick view into the same modal instead of navigating to its product page.
   (On the real product page these links still navigate normally — we only
   intercept when the link is inside a <quick-buy-modal>.)
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('.mm-siblings__link, a.mm-format__btn');
      if (!link) return;
      var modal = link.closest('quick-buy-modal');
      if (!modal) return; // only swap inside the quick-buy modal

      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      var handle = link.getAttribute('data-qv-handle') || (match ? match[1] : '');
      if (!handle) return; // let it navigate normally

      e.preventDefault();
      e.stopPropagation();

      var id = link.getAttribute('data-qv-id') || modal.getAttribute('data-id');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      fetch(root + 'products/' + handle)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var tpl = doc.getElementById('quick-buy-content');
          if (!tpl) { window.location.href = href; return; }

          Array.prototype.slice.call(tpl.content.querySelectorAll('noscript')).forEach(function (n) { n.remove(); });

          modal.setAttribute('handle', handle);
          if (id) modal.setAttribute('data-id', id);
          modal.replaceChildren(tpl.content);

          if (typeof QuickloadHwsPlans === 'function') {
            try { QuickloadHwsPlans(modal.getAttribute('data-id'), Shopify.shop); } catch (err) {}
          }
          if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) {
            try { Shopify.PaymentButton.init(); } catch (err) {}
          }

          /* Re-run the after-show inits (gallery swiper, etc.). */
          modal.dispatchEvent(new CustomEvent('dialog:after-show', { bubbles: true }));
        })
        .catch(function () { window.location.href = href; })
        .finally(function () {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        });
    },
    true
  );
})();
